/**
 * click-fraud-tracker.js — first-party storefront beacon client for the
 * click-fraud monitor service.
 */
(function(window, document) {
  'use strict';

  var config = window.iNutritionClickFraudConfig || {};
  var collectorBaseUrl = String(config.collectorBaseUrl || '').replace(/\/$/, '');
  var initPromise = null;
  var trackerToken = null;
  var engagedSent = false;
  var landingStorageKeyPrefix = 'inutrition_click_fraud_landing:';

  if (!collectorBaseUrl || typeof window.fetch !== 'function' || !window.JSON) {
    return;
  }

  function currentViewport() {
    return {
      width: window.innerWidth || null,
      height: window.innerHeight || null
    };
  }

  function buildBasePayload() {
    return {
      pageUrl: window.location.href,
      referrer: document.referrer || '',
      pageType: config.pageType || '',
      productHandle: config.resourceHandle || '',
      viewport: currentViewport()
    };
  }

  function currentPathKey() {
    return window.location.pathname || '/';
  }

  function readLandingMarker(pathKey) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(landingStorageKeyPrefix + pathKey) : null;
    } catch (error) {
      return null;
    }
  }

  function writeLandingMarker(pathKey, sessionId) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(landingStorageKeyPrefix + pathKey, sessionId);
      }
    } catch (error) {
      // Ignore storage failures; the tracker can still operate without dedupe state.
    }
  }

  function shouldSendLanding(sessionId, pathKey) {
    if (!sessionId || !pathKey) return true;
    return readLandingMarker(pathKey) !== sessionId;
  }

  function sendRequest(url, body) {
    if (navigator.sendBeacon) {
      var blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) return;
    }

    window.fetch(url, {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: {
        'content-type': 'application/json'
      },
      body: body
    }).catch(function() {
      // Ignore beacon failures in the client. Analysis should tolerate gaps.
    });
  }

  function sendEvent(eventType, extraPayload) {
    if (!trackerToken) return;

    var payload = buildBasePayload();
    var key;
    payload.eventType = eventType;
    payload.token = trackerToken;

    for (key in extraPayload) {
      if (Object.prototype.hasOwnProperty.call(extraPayload, key)) {
        payload[key] = extraPayload[key];
      }
    }

    sendRequest(collectorBaseUrl + '/v1/collect', JSON.stringify(payload));
  }

  function markEngaged(trigger) {
    if (engagedSent) return;
    engagedSent = true;
    sendEvent('engaged_view', {
      engagementTrigger: trigger
    });
  }

  function attachEngagementListeners() {
    function onScroll() {
      if ((window.scrollY || window.pageYOffset || 0) >= 120) {
        window.removeEventListener('scroll', onScroll, { passive: true });
        markEngaged('scroll');
      }
    }

    function onPointer() {
      document.removeEventListener('click', onPointer, true);
      markEngaged('click');
    }

    function onKeydown() {
      document.removeEventListener('keydown', onKeydown, true);
      markEngaged('keydown');
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', onPointer, true);
    document.addEventListener('keydown', onKeydown, true);
  }

  function attachAddToCartTracking() {
    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

      sendEvent('add_to_cart', {
        formAction: form.getAttribute('action')
      });
    }, true);
  }

  function initTracker() {
    if (initPromise) return initPromise;

    initPromise = window.fetch(collectorBaseUrl + '/v1/init', {
      method: 'GET',
      credentials: 'include'
    }).then(function(response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function(data) {
      if (!data || !data.token) return null;
      trackerToken = data.token;
      if (shouldSendLanding(data.sessionId, currentPathKey())) {
        sendEvent('landing', {});
        writeLandingMarker(currentPathKey(), data.sessionId);
      }
      attachEngagementListeners();
      attachAddToCartTracking();
      return data;
    }).catch(function() {
      return null;
    });

    return initPromise;
  }

  initTracker();
})(window, document);
